const roundToThreeNonZeroDecimals = (value: number, lg: string | 'EN' | 'DE') => {
    let formattedNumber = value.toFixed(15).replace(/0+$/, '');
    let nonZeroDecimals = formattedNumber.split('.')[1];
    let count = 0;
    let result = [];
    let index = 0;
    for (let digit of nonZeroDecimals) {
        result.push(digit);
        index += 1;
        if (digit !== '0' || (result[index-2] !== '0' && index >= 2) || (result[index-3] !== '0' && result[index-3] !== '0' && index >= 3)) {
            count += 1;
        }
        if (count === 3) {
            break;
        }
    }
    return Number(formattedNumber).toLocaleString(lg,  {maximumFractionDigits: index, useGrouping: false}) ;
}

const getFractionDigits = (value: number | undefined) => {
    if(!value) return 0;
    if((0 < value && value < 1) || (value < 0 && -1 < value)) return 3;
    if((1 <= value && value < 10) || (-10 < value && value <= -1)) return 2;
    if((10 <= value && value < 1000) || (-1000 < value && value <= -10)) return 1;
    if(value >= 1000) return 0;
    return 0;
}


export const formatNumber = (value: number | null | undefined, lg: string | 'EN' | 'DE') => {
    if(value === undefined) {
        return;
    }
    const fractionDigits = getFractionDigits(Number(value));
    return  value ? (fractionDigits === 3 ? roundToThreeNonZeroDecimals(Number(value), lg.toLocaleLowerCase()) : Number(value).toLocaleString(lg.toLocaleLowerCase(),  {maximumFractionDigits: fractionDigits, useGrouping: false})) : 0;
}


